import React, { FC } from 'react';

import { EmployeeAvatar } from '@modernloop/shared/components';
import { Badge, BadgeProps, SxProps, Theme } from '@mui/material';

type AvatarSize = 16 | 20 | 28 | 32 | 40 | 80 | 120 | 210;

interface Props {
  badgeProps?: BadgeProps;
  avatarProps?: { className?: string; sx?: SxProps<Theme> };
  icon?: JSX.Element | null;
  src: string | undefined;
  alt: string;
  dataTestId?: string;
  children?: JSX.Element | string;
  size?: AvatarSize;
}

const AvatarWithBadge: FC<Props> = ({ dataTestId, badgeProps, icon, avatarProps, src, alt, size = 20 }) => {
  return (
    <Badge
      badgeContent={
        icon ? <div style={{ width: 14, height: 14, transform: 'translate (-4px, 4px) ' }}>{icon}</div> : null
      }
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      {...badgeProps}
    >
      <EmployeeAvatar
        data-testid={dataTestId}
        imageUrl={src}
        fullName={alt}
        size={size}
        sx={avatarProps?.sx}
        className={avatarProps?.className}
      />
    </Badge>
  );
};

export default AvatarWithBadge;
